module.exports = __webpack_public_path__ + "img/vip.116c3846.svg";